import ViolationsInsights from './ViolationsInsights';

export default ViolationsInsights;
